import React, { Fragment } from "react";
import { TransitionGroup, CSSTransition } from "react-transition-group";
import WarningIcon from "./WarningIcon";
import NotificationIcon from "./NotificationIcon";
import YellowConfirm from "./YellowConfirm";
import moment from "moment";

const textAllert = [
  {
    text: "Attenzione",
    fontSize: 32,
    paddingBottom: "3vh",
  },
  {
    text:
      "L'operazione stamperà tutti gli ordini non ancora stampati e li imposterà come stampati.",
    fontSize: 18,
  },
  {
    text: "Confermi?",
    fontSize: 18,
    paddingBottom: "3vh",
  },
];

const titleFontSiza = 32;
const textFontSize = 18;

class HomeButton extends React.Component {
  state = {
    openStampa1: false,
    openStampa2: false,
    inProp: false,
    // notification: this.props.notification,
    printFrom: moment().format("YYYY-MM-DD"),
    printTo: moment().add(1, "week").format("YYYY-MM-DD"),
  };

  goToPage = (nextPage) => {
    this.props.history.push("/" + nextPage.replace(" ", ""));
  };

  confirm = () => {
    this.setState({ openStampa2: !this.state.openStampa2 });
    this.setState({ openStampa1: !this.state.openStampa1 });
    this.props.onClick({
      from: this.state.printFrom,
      to: this.state.printTo,
    });
    setTimeout(() => {
      this.setState({ openStampa2: !this.state.openStampa2 });
    }, 1200);
  };

  handleChangeDate = (e, target) => {
    this.setState({ [target]: e.target.value })
  }

  handleClickInner = (e) => {
    e.stopPropagation();
  };

  render() {
    const buttonStyle = {
      borderRadius: 16,
      border: "none",
      height: window.innerHeight * 0.16,
      width: window.innerWidth * 0.27,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: this.props.backgroundColor,
      color: this.props.text,
      boxShadow: "2px 2px 2px 0px rgba(0,0,0,0.4)",
      marginLeft: 8,
      marginRight: 8,
      marginBottom: "0.6vh",
      marginTop: "0.6vh",
      cursor: "pointer",
      fontSize: 20,
    };

    return (
      <Fragment>
        {this.props.checklist ? (
          <div style={{ position: "relative" }}>
            <button
              type={"button"}
              style={buttonStyle}
              onClick={() => this.setState({ openStampa1: !this.state.openStampa1 })}
            >
              {this.props.apartmentName}
            </button>
            <div style={{ position: "absolute", top: 0, right: 0 }}>
              <NotificationIcon size={this.props.size} notification={0} />
            </div>
            <div style={{ position: "absolute", top: 0, right: 42 }}>
              <WarningIcon size={this.props.size} warning={0} />
            </div>
          </div>
        ) : (
          <div style={{ position: "relative" }}>
            <button
              type={"button"}
              style={buttonStyle}
              onClick={() => this.goToPage(this.props.apartmentData.name)}
            >
              {this.props.apartmentName}
            </button>
            <div style={{ position: "absolute", top: 0, right: 0 }}>
              <NotificationIcon size={this.props.size} notification={this.props.notification} />
            </div>
            <div style={{ position: "absolute", top: 0, right: 42 }}>
              <WarningIcon size={this.props.size} warning={this.props.warning} />
            </div>
          </div>
        )}

        <TransitionGroup>
          <CSSTransition
            classNames={"fade"}
            key={Math.random()}
            timeout={{ enter: 500, exit: 500 }}
            in={this.state.inProp}
            unmountOnExit={true}
          >
            {this.state.openStampa1 ? (
              <div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  height: window.innerHeight,
                  width: window.innerWidth,
                  backgroundColor: "rgba(0,0,0,0.6)",
                  zIndex: 100,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                onClick={() => this.setState({ openStampa1: !this.state.openStampa1 })}
              >
                <div
                  onClick={this.handleClickInner}
                  style={{
                    backgroundColor: "white",
                    width: "40vw",
                    height: "40vh",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    zIndex: 200,
                  }}
                >
                  {textAllert.map((textAllert) => (
                    <div
                      style={{
                        fontSize: textAllert.fontSize,
                        paddingBottom: textAllert.paddingBottom,
                        paddingLeft: "4vw",
                        paddingRight: "4vw",
                      }}
                    >
                      {textAllert.text}
                    </div>
                  ))}
                  {this.props.mainChecklist && (
                    <div
                      style={{
                        display: "flex",
                        width: "60%",
                        alignItems: "center",
                        justifyContent: "space-evenly",
                        marginBottom: 24,
                      }}
                    >
                      <div>
                        Da:{" "}
                        <input
                          type="date"
                          onChange={(e) => this.handleChangeDate(e, "printFrom")}
                          value={this.state.printFrom}
                        />
                      </div>
                      <div>
                        A:{" "}
                        <input
                          type="date"
                          onChange={(e) => this.handleChangeDate(e, "printTo")}
                          value={this.state.printTo}
                        />
                      </div>
                    </div>
                  )}

                  <YellowConfirm
                    text={"Conferma"}
                    action={this.confirm}
                    padding={"1.5vh"}
                    width={"8vw"}
                  />
                </div>
              </div>
            ) : (
              <div style={{ display: "none" }}>hidden</div>
            )}
          </CSSTransition>
        </TransitionGroup>
        <TransitionGroup>
          <CSSTransition
            classNames={"fade"}
            key={Math.random()}
            timeout={{ enter: 500, exit: 500 }}
            in={this.state.inProp}
            unmountOnExit={true}
          >
            {this.state.openStampa2 ? (
              <div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  height: window.innerHeight,
                  width: window.innerWidth,
                  backgroundColor: "rgba(0,0,0,0.6)",
                  zIndex: 100,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                onClick={() => this.setState({ openStampa1: !this.state.openStampa1 })}
              >
                <div
                  style={{
                    backgroundColor: "white",
                    width: "40vw",
                    height: "40vh",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    zIndex: 200,
                  }}
                >
                  <div style={{ color: "#645B40", fontSize: 36 }}>Operazione Completata</div>
                </div>
              </div>
            ) : (
              <div style={{ display: "none" }}>hidden</div>
            )}
          </CSSTransition>
        </TransitionGroup>
      </Fragment>
    );
  }
}

export default HomeButton;
